import { Button, Drawer, Form, Space, Input } from "antd";
import { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BiExport } from "react-icons/bi";
import { RiFilterOffLine } from "react-icons/ri";
import DateLine from "../../../components/shared/DateLine";
import NoResults from "../../../components/shared/NoResults";
import formatMoney from "../../../utils/formatMoney";
import { ExportToExcel } from "../../../utils/XLSXExport";

const { Search } = Input;

export default function OperatorDetails({
  isVisible,
  setShowDetails,
  selected,
  startDate,
  endDate,
  operators,
}: any) {
  const [search, setSearch] = useState("");
  const [form] = Form.useForm();

  const handleClearSearch = () => {
    setSearch("");
    form.resetFields();
  };

  const filtered = selected?.list?.filter(
    (item: any) => item?.sales_value !== 0
  );

  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg">
            {operators[selected?._id]} Revenue :
          </span>
          <DateLine startDate={startDate} endDate={endDate} />
        </div>
      }
      placement={"right"}
      width={800}
      onClose={() => setShowDetails(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setShowDetails(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      {selected?.net === 0 ? (
        <NoResults />
      ) : (
        <div className="font-toyota">
          <div className="flex justify-between items-center border-b border-gray-300 mb-2 pb-2 -mt-4 bg-white">
            <div className="flex">
              <Form layout="inline" form={form}>
                <Form.Item name="wip">
                  <Search
                    placeholder="Search by WIP"
                    allowClear
                    onChange={(val: any) => {
                      setSearch(val.target.value);
                    }}
                    onSearch={(value: any) => {
                      setSearch(value);
                    }}
                  />
                </Form.Item>

                <Button className="" onClick={() => handleClearSearch()}>
                  <RiFilterOffLine color="#6b7280" />
                </Button>
              </Form>
            </div>
            <div className="flex ">
              <button
                color="#E50000"
                className="flex justify-center items-center border p-1 hover:bg-green-100"
              >
                <BiExport size={24} />
                <span
                  className="ml-2"
                  onClick={() =>
                    ExportToExcel(
                      filtered?.map((record: any, index: number) => {
                        return {
                          "S/N": index + 1,
                          Customer:
                            record?.company_details[0]?.name === null
                              ? "-"
                              : record?.company_details[0]?.name,
                          Department:
                            record?.department === null
                              ? "-"
                              : record?.department,

                          Invoice:
                            record?.invoice === null ? "-" : record?.invoice,
                          "RTS Code":
                            record?.rts_code === null ? "-" : record?.rts_code,
                          WIP: record?.wip === null ? "-" : record?.wip,

                          "Service Date":
                            record?.service_date === null
                              ? "-"
                              : record?.service_date,

                          Hours:
                            record?.hours_sold === null
                              ? "-"
                              : record?.hours_sold,

                          Value:
                            record?.sales_value === null
                              ? "-"
                              : record?.sales_value,
                        };
                      }),
                      "Operators.xlsx"
                    )
                  }
                >
                  Export To Excel
                </span>
              </button>
            </div>
          </div>
          <div className="flex py-1 border-b border-gray-300">
            <div className="mr-2 w-10 text-center font-bold">S/N.</div>
            <div className="flex justify-between items-center flex-1">
              <div className="flex items-center">
                <div className="w-48 truncate font-bold">Customer</div>
                <div className="w-16 ml-2 text-center font-bold">Dept</div>
                <div className="w-16 ml-2 text-left font-bold">Invoice</div>
                <div className="w-20 ml-2 text-left font-bold">RTS Code</div>
                <div className="w-16 ml-2 text-left font-bold">WIP</div>
                <div className="w-16 ml-2 text-left font-bold">Hours</div>
              </div>
              <div className="font-bold">Amount</div>
            </div>
          </div>
          {filtered
            ?.filter((revenue: any) =>
              revenue?.wip.toString()?.includes(search)
            )
            .map((item: any, index: number) => (
              <div className="flex py-1 border-b border-gray-300">
                <div className="mr-2 w-10 text-center">{index + 1}.</div>
                <div className="flex justify-between items-center flex-1">
                  <div className="flex items-center">
                    <div className="w-48 truncate">
                      {item?.company_details[0]?.name === " "
                        ? "-"
                        : item?.company_details[0]?.name}
                    </div>
                    <div className="w-16 ml-2 text-center">
                      {item?.department}
                    </div>
                    <div className="w-16 ml-2 text-left">{item?.invoice}</div>
                    <div className="w-20 ml-2 text-left">{item?.rts_code}</div>
                    <div className="w-16 ml-2 text-left">{item?.wip}</div>
                    <div className="w-16 ml-2 text-left">
                      {item?.hours_sold}
                    </div>
                  </div>
                  <div className="">{formatMoney(item?.sales_value)}</div>
                </div>
              </div>
            ))}
          <div className="flex justify-between items-start  border-t-2 border-b-2 py-2 border-gray-300 ">
            <div className=""></div>
            <div className="font-bold">{formatMoney(selected?.net)}</div>
          </div>
        </div>
      )}
    </Drawer>
  );
}
